import { Form, Input, Button, Checkbox, Flex } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import "./login.css"
import { ajaxFetchCall } from '../../services/ApiService';
import { backendUrl } from "../../Config"
import { UserContext } from '../context/UserContext';
import { useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';


export default function Login(props) {


    const [user, setUser] = useContext(UserContext);
    const navigate = useNavigate();

    const onFinish = async (values) => {
        try {
            let data = await ajaxFetchCall(backendUrl + "/user/login", { method: "POST", body: JSON.stringify(values) })
            setUser(data["response"])
            navigate("/")
        } catch (err) {
            console.log("err is ", err);
        }
    };

    return <Flex justify='center' align="center" style={{ height: '70vh' }}>
        <Form
            name="normal_login"
            className="login-form"
            initialValues={{
                remember: true,
            }}
            onFinish={onFinish}
        >
            <Form.Item
                name="username"
                rules={[
                    {
                        required: true,
                        message: 'Please input your Username!',
                    },
                ]}
            >
                <Input prefix={<UserOutlined className="site-form-item-icon" />} placeholder="Username" />
            </Form.Item>
            <Form.Item
                name="password"
                rules={[
                    {
                        required: true,
                        message: 'Please input your Password!',
                    },
                ]}
            >
                <Input
                    prefix={<LockOutlined className="site-form-item-icon" />}
                    type="password"
                    placeholder="Password"
                />
            </Form.Item>

            <Form.Item>
                <Button type="primary" htmlType="submit" className="login-form-button">
                    Log in
                </Button>

            </Form.Item>
        </Form>
    </Flex>
}